import { HighlightedText } from '@/components/ui/highlighted-text';
import { ShipmentModel } from '@/lib/models/shipment/types';
import { getShipmentIdTypeLabel } from '@/lib/models/shipment/utils/get-shipment-id-type';
import { tv } from '@/utils/styles';

export interface ShipmentLabelProps {
  shipment: ShipmentModel;
  variant?: 'lg';
  highlightText?: string;
}

const ShipmentLabel = ({ shipment, variant, highlightText }: ShipmentLabelProps) => {
  const shipmentId = getShipmentIdTypeLabel(shipment);

  const { base, label } = styles({ variant });
  return (
    <div className={base()}>
      <b className={label()}>
        <HighlightedText text={shipmentId.label} highlight={highlightText} />
      </b>
    </div>
  );
};

const styles = tv({
  slots: {
    base: '',
    label: 'flex items-center font-medium',
  },
  variants: {
    variant: {
      lg: {
        label: 'flex items-center text-baseLg font-semibold',
      },
    },
  },
});

export { ShipmentLabel };
